import ApiService from './ApiService';

export default class RolesService {
  static fetchAll() {
    return ApiService.get('roles');
  }
}
